import { ReactComponent as Icon } from "../files/check-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const CheckIcon = ({ fill, style }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default CheckIcon;
